import { AxiosResponse } from 'axios';
import { saveAs } from 'file-saver';
import React from 'react';
import { useIntl } from 'react-intl';

import toast from '@app/partials/content/Toast';

export interface Props {
    title: string;
    route: () => Promise<AxiosResponse<ArrayBuffer>>;
}

const AlertsDocumentDownloadButton = ({ title, route }: Props) => {
    const [downloading, setDownloading] = React.useState(false);

    const Intl = useIntl();

    const download = () => {
        setDownloading(true);

        route()
            .then((response) => {
                const filename = response.headers['content-disposition'].replace(/^.*filename=(.*)$/, '$1');
                setDownloading(false);
                saveAs(new Blob([response.data]), filename);
            })
            .catch(() => {
                setDownloading(false);
                toast({
                    variant: 'danger',
                    message: Intl.formatMessage({
                        id: 'CUSTOMER.VIEW.LIFE.DETAIL.PROJECT.ACTIVITIES.MODAL.DOWNLOADING_ERROR',
                    }),
                });
            });
    };

    return (
        <button type="button" onClick={() => download()} className="d-flex align-items-center btn-download-document">
            <i className="la la-2x la-file-download" />
            {title}
            {downloading && <span className="spinner-border spinner-border-sm ml-2" aria-hidden="true" />}
        </button>
    );
};

export default AlertsDocumentDownloadButton;
